import { Button } from '@/components/Button'
import useTranslation from '@/hooks/useTranslation'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import { Link } from '@tanstack/react-router'
import { useEffect } from 'react'

export default function NotFound() {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  const { t } = useTranslation()

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="#F7FAFC"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={30}
    >
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        bg="#F7FAFC"
        borderRadius="lg"
        maxWidth="md"
        mx={5}
      >
        <Stack direction="column" alignItems="center" gap={3}>
          <Text fontSize="7xl" fontWeight="bold" color="gray.400">
            404
          </Text>
          <Text
            fontSize="3xl"
            fontWeight="medium"
            color="gray.600"
            textAlign="center"
          >
            {t('page_not_found')}
          </Text>
          <Text fontSize="lg" color="gray.500" textAlign="center">
            {t('page_not_found_description')}
          </Text>
          <Link to="/">
            <Button colorPalette="hep" size="lg" mt={4}>
              {t('back_to_home')}
            </Button>
          </Link>
        </Stack>
      </Flex>
    </Box>
  )
}
